import type { AttendanceManagementCommandStatus } from "../../../../models/AttendanceManagement";

type AttendanceStatus = AttendanceManagementCommandStatus | string;

type AttendanceStatusTone = "success" | "attention" | "danger";

function getStatusTone(status: AttendanceStatus): AttendanceStatusTone {
    const normalizedStatus = status.trim().toLowerCase();

    if (normalizedStatus === "completed" || normalizedStatus === "success") {
        return "success";
    }

    return normalizedStatus === "failed" || normalizedStatus === "deadlettered"
        ? "danger"
        : "attention";
}

function formatStatus(status: AttendanceStatus): string {
    const normalizedStatus = status.trim();
    const labels: Record<string, string> = {
        queued: "Queued",
        processing: "Processing",
        completed: "Completed",
        failed: "Failed",
        deadlettered: "Dead lettered",
        unknown: "Unknown",
        success: "Success",
    };

    if (normalizedStatus.length === 0) {
        return "Unknown";
    }

    return labels[normalizedStatus.toLowerCase()]
        ?? `${normalizedStatus.charAt(0).toUpperCase()}${normalizedStatus.slice(1)}`;
}

export default function AttendanceStatusChip(props: { status: AttendanceStatus }) {
    const tone = getStatusTone(props.status);

    return (
        <span className={`attendance-status-chip is-${tone}`}>
            {formatStatus(props.status)}
        </span>
    );
}